// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"_2q4rt","icon":"_2Yc1C","title":"dbKMF","content":"_1_HHZ"};